export default __webpack_public_path__ + "static/media/rhea-arun-new.053b294c.jpg";